import { InputProps, Tooltip, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';
import FileUpload from 'react-material-file-upload';
import { cepMask } from './mask/cep';
import { cpfAndCnpjMask } from './mask/cpfAndCnpj';
import { numberMask } from './mask/number';
import { phoneMask } from './mask/phone';
import { toUpperCaseMask } from './mask/toUpperCase';
import { IButtonProps } from '../icons';

export interface IFormInputProps extends InputProps {
    variant?: 'outlined' | 'standard' | 'filled' | undefined;
    name: string;
    control: any;
    rules?: any;
    label: string;
    messageError?: (errors: any, field: any) => string;
    handleChange?: any;
    handleOnKeyPress?: (data: any, name?: string) => void;
    handleOnBlur?: (data: any) => void;
    ref?: any;
    autoFocus?: boolean;
    readOnly?: boolean;
    size?: 'small' | 'medium' | undefined;
    sx?: any;
    type?: any;
    multiline?: boolean;
    mask?:
        | 'phone'
        | 'number'
        | 'identification'
        | 'cep'
        | 'toUpperCase'
        | undefined;
    hidden?: boolean;
    inactiveRandomId?: boolean;
    messagesError?: { type: string; message: string }[];
    actionOnInput?: {
        action: () => void;
        iconProps: IButtonProps;
        textTooltip: string;
    };
    activeDebounce?: boolean;
    setValue?: (key: string, value: any) => void;
    setError?: (field: any, customError: any) => void;
    clearErrors?: (field: any) => void;
    id?: string;
    buttonText?: string;
    maxSize?: number;
    accept?: string[];
}

export const execMask = (mask: string, value: string, onBlur: boolean) => {
    switch (mask) {
        case 'phone':
            return phoneMask(value, onBlur);
        case 'number':
            return numberMask(value);
        case 'identification':
            return cpfAndCnpjMask(value, onBlur);
        case 'cep':
            return cepMask(value, onBlur);
        case 'toUpperCase':
            return toUpperCaseMask(value, onBlur);

        default:
            return '';
    }
};

export const FormFileUpload = ({ variant, name, control }: IFormInputProps) => {
    if (!variant) {
        variant = 'outlined';
    }

    return (
        <>
            <Typography variant="body2" color="textSecondary" paragraph>
                Para que a substituição de variáveis funcione no template, elas
                devem estar entre chaves. Ex.: <strong>{'{cliente}'}</strong>
            </Typography>
            <Controller
                render={({ field: { value, onChange } }) => (
                    <FileUpload
                        value={value}
                        onChange={onChange}
                        multiple={false}
                        accept={[
                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        ]}
                        title="Clique no selecionar para subir o arquivo. (Tamanho máximo: 10MB)."
                        buttonText="Selecionar arquivo"
                        maxSize={10 * 1024 * 1024}
                        buttonProps={{
                            variant: 'outlined',
                            id: name,
                        }}
                        typographyProps={{
                            variant: 'inherit',
                            color: 'textSecondary',
                        }}
                        data-qa={name}
                    />
                )}
                control={control}
                name={name}
            />
        </>
    );
};
